import cssVars from 'css-vars-ponyfill';
import VueLazyload from 'vue-lazyload'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//IEカスタムプロパティ対応
cssVars();

//遅延ロード対応 1x1のbase64白画像
//店舗画像が無かったときに白画像を代用表示させる
Vue.use(VueLazyload, {
	preLoad: 1.3,
	error: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12NgYAAAAAMAASDVlMcAAAAASUVORK5CYII=',
	loading: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12NgYAAAAAMAASDVlMcAAAAASUVORK5CYII=',
	attempt: 1
})

Vue.config.productionTip = false

let app = new Vue({
	methods: {
		junpShopInfo(_id) {
			this.$router.push('/'+_id)
		}
	},
	router,
	store,
	render: h => h(App),
}).$mount('#app');

window.app = app;